// Libraries
var React = require('react');

// Components
//var RestrictedComponent = require('RestrictedComponent/RestrictedComponent');

require('./DynamicYieldPlaceholderModule.scss')

class DynamicYieldPlaceholderModule extends React.Component {

	render() {
		return (
			<div class="DynamicYieldPlaceholder" ref="dyPlaceholder">
				{/*<RestrictedComponent hasAccess={this.props.hasAccess} isVideo={false}>*/}
					<div class="DynamicYieldPlaceholder__inner" id={this.props.data.placeholderId}></div>
				{/*</RestrictedComponent>*/}
			</div>
		)
	}
}

module.exports = DynamicYieldPlaceholderModule;



// WEBPACK FOOTER //
// ./src/components/DynamicYieldPlaceholder/DynamicYieldPlaceholderModule.js